/**
 * Gets the base URL from the window object.
 * This is set by a script in index.html that reads from the data-base-url attribute.
 * 
 * @returns {string} The base URL path (e.g., '/admissions' or '')
 */
export const getBaseUrl = () => {
  return window.APP_BASE_URL || '';
};

export default getBaseUrl;

